import { Routes, Route, Navigate } from "react-router-dom";
import Login from "../pages/Login/Login";
import RegistrationContainer from "../pages/Register/RegistrationContainer";
import ForgetPassword from "../pages/ForgetPassword/ForgetPassword";
import ResetPassword from "../pages/ForgetPassword/ResetPassword";
import PublicLayout from "../layouts/PublicLayout";
import Verification from "../pages/2FA_Email/Verification";
import AllCoursesPage from "../pages/Landing/AllCoursesPage";

function PublicRoutes() {
  return (
    <PublicLayout>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<RegistrationContainer />} />
        <Route path="/verification" element={<Verification />} />
        <Route path="/password/forget" element={<ForgetPassword />} />
        <Route path="/password/reset" element={<ResetPassword />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </PublicLayout>
  );
}

export default PublicRoutes;
